import React from 'react';
import PropTypes from 'prop-types';
import { efesBorder } from '../../theme';

const Email = ({ width, height, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 12">
    <path
      id="Path_2112"
      data-name="Path 2112"
      d="M14.5-12H1.5A1.5,1.5,0,0,0,0-10.5v9A1.5,1.5,0,0,0,1.5,0h13A1.5,1.5,0,0,0,16-1.5v-9A1.5,1.5,0,0,0,14.5-12Zm0,1.5v1.275c-.7.571-1.818,1.458-4.206,3.328C9.768-5.483,8.725-4.489,8-4.5c-.725.012-1.768-.983-2.294-1.4C3.318-7.767,2.2-8.654,1.5-9.225V-10.5Zm-13,9V-7.3c.716.57,1.732,1.371,3.279,2.583C5.462-4.18,6.658-2.993,8-3s2.516-1.162,3.22-1.717C12.768-5.929,13.784-6.73,14.5-7.3v5.8Z"
      transform="translate(0 12)"
      fill={color}
    />
  </svg>

);

Email.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

Email.defaultProps = {
  width: 14,
  height: 12,
  color: efesBorder,
};

export default Email;
